import React from 'react';
import { Icon, Text } from '@chakra-ui/react';
import { FiMapPin } from 'react-icons/all';

export interface LocationProps {
  location: string;
}
export const Location = (props: LocationProps): JSX.Element => {
  const { location } = props;

  return (
    <Text fontSize={'sm'} color={'gray.600'}>
      <Icon as={FiMapPin} color={'red.400'} fontSize={'xl'} mr={2} />
      {location}
    </Text>
  );
};
